import { loginRequest } from "../authConfig";
import { msalInstance } from "../index";

import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export async function getTokenPopup(account) {
    let request = {
        ...loginRequest,
        account: account,
    };

    return await msalInstance.acquireTokenSilent(request).catch(async (error) => {
        if (error) {
            return msalInstance.acquireTokenPopup(request).catch((error) => {
                return msalInstance.acquireTokenRedirect(request).catch((error) => {
                    sessionStorage.clear();
                    window.location.reload();
                });
            });
        } else {
            sessionStorage.clear();
            window.location.reload();
            return error;
        }
    });
}

axios.interceptors.request.use(
    async function (config) {
        console.log(msalInstance.getAllAccounts());
        const account = msalInstance.getActiveAccount();
        if (config.url && account) {
            const token = await getTokenPopup(account);
            console.log(token.accessToken);
            if (config.url.indexOf(IdentityServerUrl) == 0) {
                config.headers["Authorization"] = `Bearer ${token.accessToken}`;
            } else if (config.url.indexOf(ServiceManagerUrl) == 0) {
                config.headers["Authorization"] = `IdentityBearer ${token.accessToken}`;
            }
        }

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(function (response) {
    if (response.status == 401) {
        const account = msalInstance.getActiveAccount();
        if (account) {
            msalInstance.acquireTokenRedirect({
                ...loginRequest,
                account: account,
            });
        } else {
            msalInstance.acquireTokenRedirect({
                ...loginRequest,
            });
        }
    }
    return response;
});

export let TrimFields = (obj) => {
    Object.keys(obj).map((k) => obj[k] && (obj[k] = obj[k].trim()));
    return obj;
};

export default axios;

export interface DefaultResponse {
    success: boolean;
    message: string;
    errors: ErrorCollection;
}

export interface TypedResponse<T> extends DefaultResponse {
    value: T;
}

export interface ErrorCollection {
    errors: ErrorItem[];
    hasErrors: boolean;
}

export interface ErrorItem {
    message: string;
    error: string;
}
